import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import {
  getRolePermissions
} from 'src/services/authService';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';
import TaskAssignmentView from './TaskAssignmentView';
import './TaskAssignment.css';

function TaskAssignment() {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs.filter((fil) => fil.name === 'Activity Management');
      setPermissions(arr[0].permissions);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Task Assignment</title>
      </Helmet>
      <Container maxWidth="xl" className='task-management-container'>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <div>
              <iframe
                title="frame"
                id="my_iframe"
                style={{ display: 'none' }}
              ></iframe>
              <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
                <Grid item display='flex'>
                  <Typography
                    style={{
                      marginLeft: '0px',
                      fontWeight: '700',
                      fontSize: '16px',
                      fontFamily:
                        'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                    }}
                  >
                    Timesheet / 
                  </Typography>
                  <Typography variant="subtitle2" className='sub-title'> Task Assignment</Typography>
                </Grid>
              </Grid>
            </div>
            <TaskAssignmentView
              permissions={permissions}/>
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
}

export default TaskAssignment;
